export const locations = [
  // {
  //   id: 'bengaluru',
  //   name: 'Bengaluru (Head Office)',
  //   address: {
  //     line1: 'Plot No. 45, Industrial Estate',
  //     line2: 'Peenya 2nd Stage',
  //     city: 'Bengaluru',
  //     state: 'Karnataka',
  //     pincode: '560058',
  //   },
  //   phone: '+91-80-2345-6789',
  //   email: 'info@envirotech-solutions.com',
  //   hours: {
  //     weekdays: 'Monday - Saturday: 09:30 AM - 05:45 PM',
  //     weekend: 'Sunday: Holiday',
  //   },
  //   coordinates: {
  //     lat: 13.0297,
  //     lng: 77.5178,
  //   },
  //   isPrimary: true,
  // },
  {
    id: 'hyderabad',
    name: 'Hyderabad Branch',
    address: {
      line1: '#6-3-652, Flat #6B, 6th Floor',
      line2: 'Dhruvathara Apartments, Somajiguda',
      city: 'Hyderabad',
      state: 'Telangana',
      pincode: '500082',
    },
    phone: '+91-7037733026',
    email: 'terraenvironlabs@gmail.com',
    hours: {
      weekdays: 'Monday - Saturday: 09:30 AM - 05:45 PM',
      weekend: 'Sunday: Holiday',
    },
    coordinates: {
      lat:17.418774551806617,
      // lat: 17.418947278887913, 78.45770369341739,
      lng:78.45767541715392,
      // lng: 78.3908,
    },
    isPrimary: true,
  },
];

export const businessHours = [
  { day: 'Monday', hours: '09:30 AM - 05:45 PM' },
  { day: 'Tuesday', hours: '09:30 AM - 05:45 PM' },
  { day: 'Wednesday', hours: '09:30 AM - 05:45 PM' },
  { day: 'Thursday', hours: '09:30 AM - 05:45 PM' },
  { day: 'Friday', hours: '09:30 AM - 05:45 PM' },
  { day: 'Saturday', hours: '09:30 AM - 05:45 PM' },
  { day: 'Sunday', hours: 'Closed' },
];